import { render, staticRenderFns } from "./ValidationErrors.vue?vue&type=template&id=ab35d8e2&scoped=true&"
import script from "./ValidationErrors.vue?vue&type=script&lang=js&"
export * from "./ValidationErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab35d8e2",
  null
  
)

export default component.exports